module.exports = __webpack_public_path__ + "static/img/5.0b67879.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productcenter/hsyl/ltsj/5.png
// module id = A4ML
// module chunks = 1